import { render, staticRenderFns } from "./WarningIcon.vue?vue&type=template&id=757bd0e8&scoped=true"
var script = {}
import style0 from "./WarningIcon.vue?vue&type=style&index=0&id=757bd0e8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "757bd0e8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('757bd0e8')) {
      api.createRecord('757bd0e8', component.options)
    } else {
      api.reload('757bd0e8', component.options)
    }
    module.hot.accept("./WarningIcon.vue?vue&type=template&id=757bd0e8&scoped=true", function () {
      api.rerender('757bd0e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/atoms/WarningIcon.vue"
export default component.exports